module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "app__main",
    attrs: {
      "id": "app"
    }
  }, [(_vm.globals.spinnerVisible) ? _c('div', {
    staticClass: "loading"
  }) : _vm._e(), _vm._v(" "), _c('nav', {
    staticClass: "navbar",
    class: {
      db_layout: _vm.feature.isDBTarget
    },
    attrs: {
      "id": "app-navbar"
    }
  }, [_c('div', {
    staticClass: "container-fluid",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    class: {
      active: !_vm.$route.name
    }
  }, [_c('a', {
    staticStyle: {
      "padding": "10px"
    }
  }, [(_vm.feature.isAudiTarget) ? _c('img', {
    attrs: {
      "src": "/static/audi_loop_logo.png",
      "height": "40"
    }
  }) : (_vm.feature.isDBTarget) ? _c('img', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "src": "/static/DB_loop_service_store_logo.png",
      "height": "25"
    }
  }) : (_vm.feature.isPorscheTarget) ? _c('img', {
    staticStyle: {
      "margin-top": "5px"
    },
    attrs: {
      "src": "/static/Porsche_loop_logo.png",
      "height": "35"
    }
  }) : _c('img', {
    attrs: {
      "src": "/static/msm_loop_logo.png",
      "height": "40"
    }
  })])])]), _vm._v(" "), (!_vm.globals.isSmallScreen() && !_vm.$appService.isKeycloakUser()) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [(
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll')
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'SurveyView'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/surveyview"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0014))])], 1) : _vm._e(), _vm._v(" "), (
    !_vm.globals.isSurveyCodeUser &&
    _vm.globals.isAccessAllowed('LoopOp_SurveyInstancesAnswers_ReadAll')
  ) ? _c('li', {
    class: {
      active: _vm.$route.name === 'Settlement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settlement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0030))])], 1) : _vm._e(), _vm._v(" "), (!_vm.globals.isSurveyCodeUser && _vm.globals.currentUserInfo) ? _c('li', {
    class: {
      active: _vm.$route.name === 'FreeOffers'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/freeoffers"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0019))])], 1) : _vm._e()]) : (!_vm.$appService.isKeycloakUser()) ? _c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.currentRouteHeaderTranslation) + "\n            "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', {
    class: {
      'dropdown-active': _vm.$route.name === 'SurveyView'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/surveyview"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0014))])], 1), _vm._v(" "), (
    !_vm.globals.isSurveyCodeUser &&
    _vm.globals.isAccessAllowed(
      'LoopOp_SurveyInstancesAnswers_ReadAll'
    )
  ) ? _c('li', {
    class: {
      'dropdown-active': _vm.$route.name === 'Settlement'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/settlement"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0030))])], 1) : _vm._e(), _vm._v(" "), (!_vm.globals.isSurveyCodeUser) ? _c('li', {
    class: {
      'dropdown-active': _vm.$route.name === 'FreeOffers'
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/freeoffers"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0019))])], 1) : _vm._e()])])]) : _vm._e(), _vm._v(" "), (_vm.userLoginState && !_vm.$appService.isKeycloakUser()) ? _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.openSelectLanguageDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("public")]), _vm._v("\n            " + _vm._s(_vm.globals.isMobileBrowser ?
    _vm.globals.selectedLanguage.toUpperCase() :
    _vm.languageList[_vm.globals.selectedLanguage]) + "\n          ")])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("person")]), _vm._v("\n            " + _vm._s(_vm.globals.isMobileBrowser ? "" : _vm.globals.currentUserInfo.LoginName) + "\n            "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [(_vm.globals.isSmallScreen()) ? _c('li', [_c('a', {
    staticStyle: {
      "pointer-events": "none"
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("person")]), _vm._v("\n                " + _vm._s(_vm.globals.currentUserInfo.LoginName) + "\n              ")])]) : _vm._e(), _vm._v(" "), (!_vm.globals.isSurveyCodeUser) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.showShopperProfileModal = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("portrait")]), _vm._v("\n                " + _vm._s(_vm.lang.A0004) + "\n              ")])]) : _vm._e(), _vm._v(" "), (
    !_vm.globals.isSurveyCodeUser &&
    _vm.globals.isAccessAllowed(
      'LoopOp_Password_ChangePasswordSelf'
    ) &&
    _vm.globals.isAccessAllowed('LoopOp_Password_ValidatePassword')
  ) ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        _vm.showChangePasswordDialog = true
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("vpn_key")]), _vm._v("\n                " + _vm._s(_vm.lang.A0031) + "\n              ")])]) : _vm._e(), _vm._v(" "), (_vm.globals.selectedLanguage === 'de') ? _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.showHelpMessage()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("help_outline")]), _vm._v("\n                " + _vm._s(_vm.lang.A0022) + "\n              ")])]) : _vm._e(), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.triggerAppRegistrationPopup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("smartphone")]), _vm._v("\n                " + _vm._s(_vm.lang.A0034) + "\n              ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "role": "button"
    },
    on: {
      "click": function($event) {
        return _vm.userLogout()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-24"
  }, [_vm._v("exit_to_app")]), _vm._v("\n                " + _vm._s(_vm.lang.A0003) + "\n              ")])])])])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "app__router-view"
  }, [(_vm.isAccessTokenAvailable) ? _c('router-view', {
    key: _vm.$route.fullPath
  }) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "selectLanguageDialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.A0006))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.A0007))])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-8 col-md-offset-2",
    staticStyle: {
      "padding-bottom": "20px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.nextLanguage),
      expression: "nextLanguage"
    }],
    staticClass: "form-control language-select",
    attrs: {
      "id": "selectLanguage"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.nextLanguage = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.languageList), function(language, isocode) {
    return _c('option', {
      key: isocode,
      domProps: {
        "value": isocode
      }
    }, [_vm._v("\n                  " + _vm._s(language) + "\n                ")])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default dialog-btn-primary",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.changeSelectedLanguage
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.A0009) + "\n          ")])])])])]), _vm._v(" "), _c('ShopperProfile', {
    attrs: {
      "showDialog": _vm.showShopperProfileModal
    },
    on: {
      "modalClosed": function($event) {
        _vm.showShopperProfileModal = false
      }
    }
  }), _vm._v(" "), (_vm.showChangePasswordDialog) ? _c('ChangePasswordDialog', {
    attrs: {
      "showDialog": _vm.showChangePasswordDialog
    },
    on: {
      "dialogClosed": function($event) {
        _vm.showChangePasswordDialog = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('ConfirmationDialog', {
    attrs: {
      "dialogId": _vm.confirmationDialogId,
      "confirmationTitle": _vm.confirmationDialogData.confirmationTitle,
      "yesButtonText": _vm.confirmationDialogData.yesButtonText,
      "noButtonText": _vm.confirmationDialogData.noButtonText,
      "showDialog": _vm.showConfirmationDialog,
      "colorRed": _vm.confirmationDialogData.colorRed,
      "htmlText": _vm.confirmationDialogData.htmlText
    },
    on: {
      "onYesConfirmation": _vm.onYesConfirmation,
      "onNoConfirmation": _vm.onNoConfirmation,
      "dialogClosed": _vm.onConfirmationDialogClosed
    }
  }), _vm._v(" "), _c('NotificationDialog', {
    attrs: {
      "dialogId": _vm.notificationDialogId,
      "notificationTitle": _vm.notificationDialogData.notificationTitle,
      "closeButtonText": _vm.notificationDialogData.closeButtonText,
      "showDialog": _vm.showNotificationDialog,
      "colorRed": _vm.notificationDialogData.colorRed,
      "htmlText": _vm.notificationDialogData.htmlText
    },
    on: {
      "closeDialog": _vm.onCloseNotificationDialog,
      "dialogClosed": _vm.onNotificationDialogClosed
    }
  }), _vm._v(" "), _c('UploadProgressModal'), _vm._v(" "), _c('AppRegistrationModal', {
    attrs: {
      "showModal": _vm.showAppRegistrationModal
    },
    on: {
      "close": function($event) {
        return _vm.closeAppRegistrationModal()
      }
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "id": "defaultAppFooter"
    }
  }, [_c('span', {
    attrs: {
      "id": "footerLinkContainer"
    }
  }, [_c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/imprint.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0018))]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ("https://" + _vm.mainOpHost + "/dataProtection.html"),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.lang.A0017))])]), _vm._v(" "), _c('span', {
    attrs: {
      "id": "frontendVersionIndicator"
    }
  }, [_vm._v("v" + _vm._s(_vm.appVersion))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bd26cd6c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1098
// module chunks = 2